import styled from "styled-components";
import { pxToRem } from "styles/utils";

/**
 * Базовый layout для полноэкранных страниц со shared Table.
 * Заголовки, breadcrumbs, метрики и toolbar занимают естественную высоту,
 * а Table как flex-ребёнок получает всё оставшееся место карточки.
 */
export const TablePageContainer = styled.div`
  display: flex;
  height: calc(100% - ${({ theme }) => pxToRem(theme.spacing.xl)});
  margin: ${({ theme }) => pxToRem(theme.spacing.sm)};
`;

export const TablePageContent = styled.div`
  min-width: 0;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const TablePageCard = styled(TablePageContent)`
  padding: ${({ theme }) => pxToRem(theme.spacing.xxl)} ${({ theme }) => pxToRem(theme.spacing.xl)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
`;

export const TablePageTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xxl)};
  font-weight: 700;
  line-height: 1.2;
`;
